/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/feature/logout/logout.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '@angular/core/src/linker/view_type';
import * as import6 from '@angular/core/src/change_detection/constants';
import * as import7 from '@angular/core/src/linker/component_factory';
import * as import8 from 'ngx-cookie/src/cookie.service';
import * as import9 from '../../../../../public/upgrade/core/logout.service';
import * as import10 from '../../../../../public/upgrade/core/session.service';
import * as import11 from '../../../../../public/upgrade/root/loading/loading-wheel.service';
import * as import12 from '@ngx-translate/core/src/translate.pipe';
import * as import13 from '@angular/core/src/change_detection/change_detection_util';
import * as import14 from '@ngx-translate/core/src/translate.service';
import * as import15 from '@angular/core/src/security';
export class Wrapper_LogoutComponent {
  /*private*/ _eventHandler:Function;
  context:import0.LogoutComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any) {
    this._changed = false;
    this.context = new import0.LogoutComponent(p0,p1,p2,p3);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_LogoutComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_LogoutComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.LogoutComponent>;
  _LogoutComponent_0_3:Wrapper_LogoutComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_LogoutComponent_Host0,renderType_LogoutComponent_Host,import5.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'logout-component',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_LogoutComponent0(this.viewUtils,this,0,this._el_0);
    this._LogoutComponent_0_3 = new Wrapper_LogoutComponent(this.injectorGet(import8.CookieService,this.parentIndex),this.injectorGet(import9.LogoutService,this.parentIndex),this.injectorGet(import10.SessionService,this.parentIndex),this.injectorGet(import11.LoadingWheelService,this.parentIndex));
    this.compView_0.create(this._LogoutComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import7.ComponentRef_<any>(0,this,this._el_0,this._LogoutComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.LogoutComponent) && (0 === requestNodeIndex))) { return this._LogoutComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._LogoutComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const LogoutComponentNgFactory:import7.ComponentFactory<import0.LogoutComponent> = new import7.ComponentFactory<import0.LogoutComponent>('logout-component',View_LogoutComponent_Host0,import0.LogoutComponent);
const styles_LogoutComponent:any[] = ([] as any[]);
var renderType_LogoutComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_LogoutComponent,{});
export class View_LogoutComponent0 extends import1.AppView<import0.LogoutComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  _text_17:any;
  /*private*/ _expr_18:any;
  /*private*/ _expr_19:any;
  _pipe_translate_0:import12.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_LogoutComponent0,renderType_LogoutComponent,import5.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways);
    this._expr_18 = import13.UNINITIALIZED;
    this._expr_19 = import13.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'ng-include',new import3.InlineArray2(2,'src','\'templates/partial/anonymous-header.html\''),(null as any));
    this._text_1 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','reset-styles'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','container-fluid login'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n\n        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','login-content animated fadeIn'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n\n            ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','text-center'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'img',new import3.InlineArray2(2,'alt',''),(null as any));
    this._text_11 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_8,'p',new import3.InlineArray2(2,'class','login-text-info ng-binding'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_8,'\n            ',(null as any));
    this._text_15 = this.renderer.createText(this._el_6,'\n        ',(null as any));
    this._text_16 = this.renderer.createText(this._el_4,'\n    ',(null as any));
    this._text_17 = this.renderer.createText(this._el_2,'\n',(null as any));
    this._pipe_translate_0 = new import12.TranslatePipe(this.parentView.injectorGet(import14.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._text_16,
      this._text_17
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import13.ValueUnwrapper();
    const currVal_18:any = this.context.langLogo;
    if (import3.checkBinding(throwOnChange,this._expr_18,currVal_18)) {
      this.renderer.setElementProperty(this._el_10,'src',this.viewUtils.sanitizer.sanitize(import15.SecurityContext.URL,currVal_18));
      this._expr_18 = currVal_18;
    }
    valUnwrapper.reset();
    const currVal_19:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('logout.LOGGING_OUT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_19,currVal_19))) {
      this.renderer.setText(this._text_13,currVal_19);
      this._expr_19 = currVal_19;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/logout/logout.component.ngfactory.ts